import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CustomCollapseCard, Text, CustomRadioGroup, CustomRadio } from '@src/components';

import {
  setTotalAutoLoading,
  updateAutoLoadingCommand,
} from '@src/store/slice/autoUploadInstructionsSlice';

import '@src/styles/balanceUpload/orderType.scss';

const InstructionType = () => {
  const dispatch = useDispatch();

  const { totalAutoLoading, autoLoadingId, integrationId } = useSelector(
    (state) => state?.autoUploadInstructions,
  );

  const onChangeType = async (e) => {
    dispatch(
      setTotalAutoLoading({
        ...totalAutoLoading,
        orderProcessType: e.target.value,
      }),
    );

    const data = {
      periodType: totalAutoLoading?.periodType,
      confirmEveryMonth: totalAutoLoading?.confirmEveryMonth,
      startDay: totalAutoLoading?.startDay,
      isActive: totalAutoLoading?.isActive,
      orderProcessType: e.target.value,
      monthChoice: totalAutoLoading?.chooseMonth,
    };

    if (autoLoadingId && autoLoadingId > 0) {
      data.id = autoLoadingId;
    }

    if (integrationId && integrationId > 0) {
      data.integrationId = integrationId;
    }

    await dispatch(updateAutoLoadingCommand(data));
  };

  return (
    <CustomCollapseCard
      className="order-type-card order-input-form-page"
      bodyCenter
      cardTitle={<Text t="selectInstructionType" />}
      cardTitleAlign="center"
    >
      <CustomRadioGroup
        id="ticketRestaurant-autoUploadInstructions-instructionInformations-instructionType-radioGroup"
        onChange={onChangeType}
        value={totalAutoLoading?.orderProcessType}
      >
        <CustomRadio
          id="ticketRestaurant-autoUploadInstructions-instructionInformations-instructionType-radio-2"
          value={2}
          title={<Text t="giveInstructionWithManualSelection" />}
          description={
            <Text t="youCanEnterInformationForCardsYouWant2" />
          }
        />
      </CustomRadioGroup>
    </CustomCollapseCard>
  );
};

export default InstructionType;
